module.exports = __webpack_public_path__ + "images/directory/featured-hero/dropbox@2x.ebfbef7f807840eaa2f3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/dropbox@2x.png
// module id = sxEV
// module chunks = 2